// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.service-bg[data-v-426d81af] {\r\n  background: #f7f7f7;\r\n  border-radius: 5px;\r\n  margin: 10px 0 0 0;\r\n  padding: 15px;\n}\n.service-title[data-v-426d81af] {\r\n  color: #727272;\r\n  font: normal normal normal 14px/28px Lato;\r\n  font-weight: 700;\n}\n.service-content[data-v-426d81af] {\r\n  color: #11291b;\r\n  font: normal normal normal 16px/20px Lato;\n}\r\n", ""]);
// Exports
module.exports = exports;
